@if(loader){
<app-loader></app-loader>
}


<form [formGroup]="createprojectform">

    <div class="field col-12 flex justify-content-between align-items-center">
        <div class="flex">

            <p-button label="Save" class="p-button-outlined ml-2" icon="pi pi-save" size="small"
                (click)="saveProjectBOM(createprojectform.value, isEditMode)"></p-button>
        </div>

        <div>
            <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>
    </div> <br>

    <div class="grid">
        <div class="col-12 md:col-6 field text-left">
            <label class="block label-required">Project Code</label>

            <div class="flex align-items-center">
                <input pInputText placeholder="e.g P307" type="text" formControlName="projectBoMCode"
                    (blur)="checkProductCode()" (keydown)="onKeydown($event)"
                    [readonly]="isEditMode || !formControls.manualEntry.value" class="w-full p-inputtext-sm"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.projectBoMCode.errors}" />

                <div *ngIf="!isEditMode" class="ml-2">
                    <p-checkbox formControlName="manualEntry" (onChange)="manualEntry()" [binary]="true"
                        label="Manual Entry">
                    </p-checkbox>
                </div>
            </div>
        </div>


        <div class="col-12 md:col-6 field text-left">
            <label for="BillToCustomerCode">Bill To Customer Code</label>
            <span class="p-fluid">
                <div class="flex">
                    <p-autoComplete formControlName="BillToCustomerCode" [readonly]="isEditMode"
                        (onSelect)="setBillTo($event)" [suggestions]="BillTocustomerList"
                        (completeMethod)="autosearchBilltoCustomer($event)" field="customerCode" styleClass="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.BillToCustomerCode.errors }"
                        (keydown.enter)="focusNextInput($event)">
                        <ng-template let-item pTemplate="item">
                            <span>{{item.customerCode}} - {{item.customerName}}</span>
                        </ng-template>
                    </p-autoComplete>
                    <button type="button" pButton [disabled]="products.length > 0 || isEditMode" pRipple
                        (click)="showBillToCustomerDialog()" icon="pi pi-search" styleClass="p-button-warn"
                        style="margin-left: 10px;"></button>
                </div>
            </span>
        </div>


    </div>

    <div class="grid">
        <div class="col-12 md:col-6 field text-left">
            <label class="block label-required">Project Name</label>
            <input pInputText formControlName="projectBoMName" (keydown)="onKeydown($event)"
                class="w-full p-inputtext-sm"
                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.projectBoMName.errors}" />
        </div>




        <div class="col-12 md:col-6 field text-left">
            <label for="ShipToCustomerCode">Ship To Customer Code</label>
            <div class="flex">
                <p-autoComplete formControlName="ShipToCustomerCode" [readonly]="isEditMode"
                    (onSelect)="setShipTo($event)" [suggestions]="ShipTocustomerList"
                    (completeMethod)="autosearchShiptoCustomer($event)" field="customerCode" styleClass="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ShipToCustomerCode.errors }"
                    (keydown.enter)="focusNextInput($event)">
                    <ng-template let-item pTemplate="item">
                        <span>{{item.customerCode}} - {{item.customerName}}</span>
                    </ng-template>
                </p-autoComplete>
                <button type="button" pButton [disabled]="products.length > 0 || isEditMode" pRipple
                    (click)="openShipToCustomerLookup()" icon="pi pi-search" styleClass="p-button-warn"
                    style="margin-left: 10px;"></button>
            </div>
        </div>



    </div>

</form>